module.exports = __webpack_public_path__ + "static/media/studio-etc6.fbe8ee6e.png";